// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class ShowView extends JQueryView {
  constructor() {
    super('.important_meetings.show');
  }

  @on({ event: 'click', selector: '.title-header-box' })
  clickToggleContent(e: any) {
    const chevronTarget = $(e.target)
      .closest('.agenda')
      .find('.icon-chevron');
    const contentTarget = $(e.target)
      .closest('.agenda')
      .find('.content');

    if (contentTarget.hasClass('d-none')) {
      chevronTarget.removeClass('ion-chevron-right');
      chevronTarget.addClass('ion-chevron-up');
      contentTarget.removeClass('d-none');
    } else {
      chevronTarget.removeClass('ion-chevron-up');
      chevronTarget.addClass('ion-chevron-right');
      contentTarget.addClass('d-none');
    }
  }
}
